////////LIBRARY/////////
import PropTypes from 'prop-types'
import { useState } from 'react'
import { cloneDeep, isEqual, forEach, findIndex, isUndefined } from 'lodash'

const UseCheckAll = (prevFilters, submitMethod) => {
	const [filters, setFilters] = useState({})
	///////////////////////////////// HANDLE ///////////////////////////////////////

	const handleCheckElements = (id, checked, target) => {
		const filtersCP = cloneDeep(filters)
		if (id === 'checkAll') {
			forEach(filtersCP.filtersSelection[target].filterElements, (elem) => {
				if (elem.id !== 'checkAll') elem.active = !checked
			})
		} else {
			const idx = findIndex(filtersCP.filtersSelection[target].filterElements, { id: id })
			filtersCP.filtersSelection[target].filterElements[idx].active = !checked
		}

		if (!isEqual(filtersCP.filtersSelection[target].filterElements, prevFilters.filtersSelection[target].filterElements)) {
			filtersCP.filtersSelection[target].updated = true
		} else {
			filtersCP.filtersSelection[target].updated = false
		}

		setFilters(filtersCP)
	}

	const handleCheckRadio = (id, _checked, target) => {
		const filtersCP = cloneDeep(filters)

		forEach(filtersCP.filtersSelection[target].filterElements, (elem) => {
			elem.active = elem.id === id
		})

		if (!isEqual(filtersCP.filtersSelection[target].filterElements, filters.filtersSelection[target].filterElements)) {
			filtersCP.filtersSelection[target].updated = true
		}

		// Submit instantly the change, because paper will be closed
		if (!isUndefined(submitMethod)) submitMethod(filtersCP, target)

		setFilters(filtersCP)
	}

	const handleCheck = (id, checked, target, radio) => {
		if (radio) {
			handleCheckRadio(id, checked, target)
		} else {
			handleCheckElements(id, checked, target)
		}
	}

	///////////////////////////////// RENDER ///////////////////////////////////////

	return [filters, setFilters, handleCheck]
}

UseCheckAll.propTypes = {
	inputFilter: PropTypes.object.isRequired,
}

UseCheckAll.defaultPropTypes = {
	inputFilter: {},
}

export default UseCheckAll
